import { User } from 'src/app/core/models/user.model';

export interface UserLoginData {
  Email: string;
  Password: string;
  RememberMe: boolean;
}

export interface SessionState {
  loading: boolean;
  error: any;
  user: User | null;
  UILocale: string;
}

export const initialState: SessionState = {
  loading: false,
  error: null,
  user: null,
  UILocale: ''
};
